import { c as _c } from "react/compiler-runtime";
import { PrimaryButton } from '@systemeio/ui';
import { StoreTabEnum } from 'modules/stores/store/enum/store-tab-enum';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { PaletteIcon } from '@systemeio/ui/icons';
const StoreEditDesignButton = () => {
  const $ = _c(10);
  const {
    t
  } = useLocoTranslation();
  const {
    onChangeTab
  } = useStoreQuery();
  let t0;
  if ($[0] !== onChangeTab) {
    t0 = () => onChangeTab(StoreTabEnum.theme);
    $[0] = onChangeTab;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PaletteIcon className="fill-background-secondary" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t("dashboard.store.theme.edit_design");
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <span className="hidden sm:inline">{t2}</span>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t3) {
    t4 = <PrimaryButton onClick={t0}>{t1}{t3}</PrimaryButton>;
    $[7] = t0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default StoreEditDesignButton;